var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-relative tw-bg-white",staticStyle:{"min-height":"calc(100vh - 70px)"}},[_c('Header'),_vm._v(" "),_c('main',[_c('nuxt',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }